module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"update_review":"修改評論"}}')
  delete Component.options._Ctor
}
